/**
 * Course Intervention Reducers
 */
import {
    RANGEPUTTING_ACTION,
    FETCH_RANGEPUTTING,
    ADD_RANGEPUTTING,
    GET_RANGEPUTTING,
    EDIT_RANGEPUTTING,
    DELETE_RANGEPUTTING
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    rangeputtinglist:[],
    particularrangeputting:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case RANGEPUTTING_ACTION:
            return { ...state, loading: true };
 
        case FETCH_RANGEPUTTING:
            return { ...state, loading: false, rangeputtinglist: action.payload };  
            
        case ADD_RANGEPUTTING:
            return { ...state, loading: false };    

        case GET_RANGEPUTTING:
            return { ...state, loading: false, particularrangeputting: action.payload };  
            
        case EDIT_RANGEPUTTING:
            return { ...state, loading: false }; 
            
        case DELETE_RANGEPUTTING:
            return { ...state, loading: false };     
        
         default: return { ...state };
     }
 }